import AppletSubgroupTypeEnum from '../../../models/applet/applet-subgroup-type.enum';

import frontPassengerDiagonal from '../../../assets/images/inspection/examples/front-passenger-diagonal.png';
import frontDriverDiagonal from '../../../assets/images/inspection/examples/front-driver-diagonal.png';
import rearPassengerDiagonal from '../../../assets/images/inspection/examples/rear-passenger-diagonal.png';
import rearDriverDiagonal from '../../../assets/images/inspection/examples/rear-driver-diagonal.png';
import front from '../../../assets/images/inspection/examples/front.png';
import rear from '../../../assets/images/inspection/examples/rear.png';
import motor from '../../../assets/images/inspection/examples/motor.png';
import odometer from '../../../assets/images/inspection/examples/odometer.png';
import steppe from '../../../assets/images/inspection/examples/steppe.png';
import chassi01 from '../../../assets/images/inspection/examples/chassi-01.png';
import chassi02 from '../../../assets/images/inspection/examples/chassi-02.png';
import chassi03 from '../../../assets/images/inspection/examples/chassi-03.png';
import crlvNewModel from '../../../assets/images/inspection/examples/crlv-new-model.png';
import crlvOldModel from '../../../assets/images/inspection/examples/crlv-old-model.png';

export interface StepExample {
  images: string[];
  captions: string[];
}

const exampleContent: { [type: string]: StepExample } = {
  [AppletSubgroupTypeEnum.FRONT_PASSENGER_DIAGONAL]: {
    images: [frontPassengerDiagonal],
    captions: [],
  },
  [AppletSubgroupTypeEnum.FRONT_DRIVER_DIAGONAL]: {
    images: [frontDriverDiagonal],
    captions: [],
  },
  [AppletSubgroupTypeEnum.REAR_PASSENGER_DIAGONAL]: {
    images: [rearPassengerDiagonal],
    captions: [],
  },
  [AppletSubgroupTypeEnum.REAR_DRIVER_DIAGONAL]: {
    images: [rearDriverDiagonal],
    captions: [],
  },
  [AppletSubgroupTypeEnum.FRONT]: {
    images: [front],
    captions: [],
  },
  [AppletSubgroupTypeEnum.REAR]: {
    images: [rear],
    captions: [],
  },
  [AppletSubgroupTypeEnum.MOTOR]: {
    images: [motor],
    captions: [],
  },
  [AppletSubgroupTypeEnum.ODOMETER]: {
    images: [odometer],
    captions: [],
  },
  [AppletSubgroupTypeEnum.STEPPE]: {
    images: [steppe],
    captions: [],
  },
  [AppletSubgroupTypeEnum.CHASSIS]: {
    images: [chassi01, chassi02, chassi03],
    captions: [
      'Chassi - Abaixo do banco passageiro',
      'Chassi - Caixa de roda/longarina lado do passageiro',
      'Chassi - Painel corta fogo',
    ],
  },
  [AppletSubgroupTypeEnum.DOCUMENT]: {
    images: [crlvNewModel, crlvOldModel],
    captions: ['CRLV - Modelo Novo', 'CRLV - Modelo Antigo'],
  },
};

export function getStepExamples(type: string): StepExample {
  return exampleContent[type] || { images: [], captions: [] };
}

export default exampleContent;
